(function () {
  angular
    .module('kareo.ui.shared.modules.api.practice.authorization-service', [])
    .factory('authorizationService', authorizationService);

  authorizationService.$inject = ['$http'];
  function authorizationService($http) {
    const svc = {};
    svc.getUserIsAuthorized = getUserIsAuthorized;
    svc.getUserPermissions = getUserPermissions;
    return svc;

    function getUserIsAuthorized(authRequest) {
      return $http.post('/access-control-ui/api/users/authorized', authRequest, {
        cache: true
      }).then(response => {
        return response?.data?.authorized;
      });
    }
    function getUserPermissions(){
      return $http.get('/access-control-ui/api/users/permissions'); 
    }
  }
})();
